import { CircleSize, TodoStatusCircle } from "arkh";
import { TouchableOpacity } from "react-native";
import React, { useCallback } from "react";

import { graphql, useFragment } from "react-relay";

import { useTodoSetStatus } from "./useTodoSetStatus";
import { onPressInHaptic } from "widgets/src/onPressInHaptic";
import { TodoFooterCircleStatus_todo$key } from "./__generated__/TodoFooterCircleStatus_todo.graphql";

const pr = { left: 20, right: 20, top: 20, bottom: 20 };

export function TodoFooterCircleStatus(props: {
  todo: TodoFooterCircleStatus_todo$key;

  size?: CircleSize;
}) {
  const {
    id,
    expireAtDate,
    status: remoteStatus,

    canChangeStatus,
  } = useFragment(
    graphql`
      fragment TodoFooterCircleStatus_todo on Todo {
        id

        canChangeStatus
        expireAtDate {
          isoString
        }
        status
      }
    `,
    props.todo
  );

  const setRemoteStatus = useTodoSetStatus(id);

  const onPress = useCallback(() => {
    onPressInHaptic();
    setRemoteStatus(remoteStatus === "DONE" ? "PENDING" : "DONE");
  }, [remoteStatus, setRemoteStatus]);

  const isDisabled = !canChangeStatus;
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={isDisabled}
      style={{
        opacity: isDisabled ? 0.3 : 1,
      }}
      pressRetentionOffset={pr}
      hitSlop={pr}
    >
      <TodoStatusCircle
        status={remoteStatus}
        expireAtISO={expireAtDate?.isoString ?? null}
        size={props.size ?? "smallMedium"}
      />
    </TouchableOpacity>
  );
}
